module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("page_ccpa", [["div",{"class":"layout-width single-page"},[["import",{"name":"promo_ccpa_header"}],["div",{"class":"sp-main-content-wrapp"},[["import",{"name":"promo_ccpa_body"}],["div",{"class":"col sp-right"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/CCPA/templates/mc.a.tpl
// module id = 67
// module chunks = 0